import { render, staticRenderFns } from "./GSalaryLockView.vue?vue&type=template&id=39f256f3&"
import script from "./GSalaryLockView.vue?vue&type=script&lang=js&"
export * from "./GSalaryLockView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports